export default function Projects() {
  const projects = [
    {
      title: 'Magna Yuma Private Limited - LT Cable Installation',
      type: 'Industrial Infrastructure',
      description: 'Complete high-tension cable laying and installation for power distribution network',
      image: 'https://static.readdy.ai/image/fa99bb9c62df4d6cdaf96fd6599da80a/0b0128daadcb018849f65eac9f5e8815.png',
      value: 'Major Project'
    },
    {
      title: 'Bel Cibo - Advertisement Boards',
      type: 'Commercial Installation',
      description: 'Full electrical contracting including panel installation, wiring, and safety systems',
      image: 'https://static.readdy.ai/image/fa99bb9c62df4d6cdaf96fd6599da80a/6489758ccde690768d6eb576387bdc37.jpeg',
      value: 'Large Scale'
    },
    {
      title: 'Residential Complex - Phase 1',
      type: 'Residential Development',
      description: 'Complete electrical wiring for 50+ residential units with modern safety features',
      image: 'https://public.readdy.ai/ai/img_res/a40f6b6b3f1bc5417f35358af7798aee.jpg',
      value: '50+ Units'
    },
    {
      title: 'Industrial Meter Installation',
      type: 'Meter & Panel Work',
      description: 'Installation of digital meters and distribution panels for industrial facility',
      image: 'https://readdy.ai/api/search-image?query=professional%20industrial%20meter%20installation%20showing%20modern%20digital%20electricity%20meters%20and%20distribution%20panels%20being%20installed%20in%20industrial%20facility%20technical%20photography%20featuring%20organized%20electrical%20equipment%20proper%20labeling%20and%20professional%20installation%20simple%20industrial%20background%20emphasizing%20precision%20and%20technical%20expertise&width=360&height=340&seq=project-meter-001&orientation=squarish',
      value: 'Industrial'
    },
    {
      title: 'Underground Cable Network',
      type: 'Infrastructure Development',
      description: 'Underground LT cable laying for residential area power distribution',
      image: 'https://readdy.ai/api/search-image?query=underground%20electrical%20cable%20network%20installation%20showing%20organized%20cable%20laying%20work%20in%20trenches%20with%20proper%20cable%20management%20and%20safety%20measures%20professional%20construction%20photography%20featuring%20heavy%20duty%20cables%20conduits%20and%20infrastructure%20work%20simple%20construction%20site%20background%20emphasizing%20scale%20and%20professional%20execution&width=360&height=340&seq=project-underground-001&orientation=squarish',
      value: 'Network'
    }
  ];

  return (
    <section id="projects" className="py-24 bg-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-end mb-12">
          <h2 className="text-5xl font-bold">
            <span className="text-gray-900">Featured </span>
            <span className="text-sky-500">Projects</span>
          </h2>
          <div className="hidden md:block">
            <div className="px-6 py-3 bg-slate-800 text-white text-sm font-medium rounded-full cursor-pointer hover:bg-slate-900 transition-colors whitespace-nowrap">
              VIEW ALL →
            </div>
          </div>
        </div>

        <p className="text-gray-600 mb-12">Trusted by leading companies and contractors</p>

        <div className="overflow-x-auto pb-4 -mx-6 px-6">
          <div className="flex gap-5 min-w-max">
            {projects.map((project, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                style={{ width: '380px' }}
              >
                <div className="h-80">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <div className="flex-1">
                      <p className="text-xs text-gray-500 mb-2">{project.type}</p>
                      <h3 className="text-xl font-bold text-gray-900 leading-tight">
                        {project.title}
                      </h3>
                    </div>
                    <div className="text-right ml-4">
                      <div className="text-2xl font-bold text-gray-900">{project.value}</div>
                    </div>
                  </div>
                  <p className="text-sm text-gray-600 leading-relaxed">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 bg-white rounded-3xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-6">Companies We Have Worked With</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="flex items-center gap-4 p-6 bg-slate-50 rounded-2xl">
              <div className="w-12 h-12 bg-sky-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-building-4-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900">Magna Yuma Private Limited</h4>
                <p className="text-sm text-gray-600">cable laying</p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-6 bg-slate-50 rounded-2xl">
              <div className="w-12 h-12 bg-sky-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900">Bel Cibo</h4>
                <p className="text-sm text-gray-600">advertisement boards</p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-6 bg-slate-50 rounded-2xl">
              <div className="w-12 h-12 bg-sky-500 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-community-line text-2xl text-white"></i>
              </div>
              <div>
                <h4 className="font-bold text-gray-900">Local Contractors</h4>
                <p className="text-sm text-gray-600">Builders & Societies</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
